import { useProduct } from "components/product/product-context";
import Image from "next/image";

export function BundleImage({image}: {image: string}) {
    const { selectedCamera } = useProduct();
    return (
        <div className="flex flex-col md:flex-row w-full h-full bg-white rounded-2xl border-none">
            <div className="w-full px-8 flex flex-col h-full">
                <div>                    
                    <div className="w-full order-1 md:order-2 rounded-2xl py-8">
                        {selectedCamera.image !=="" && <Image src={selectedCamera.image} alt={`${selectedCamera.name} - camera`} width={800} height={800} className="w-full h-auto rounded-2xl"/>}
                    </div>  
                </div>                
            </div>
        </div>
    )
}

